import { createSlice } from '@reduxjs/toolkit';
import { RolesEnum } from '../../enums';
import { UserCompany } from '../../types';

export interface User {
  Id: string;
  Email: string;
  Name: string;
  FamilyName: string;
  CompanyName: string;
  AmazonCognitoId: string;
  Role: RolesEnum;
  Language: string;
  Country?: string;
  EmailVerifiedAt: string;
  NewsletterAgreement: boolean;
  LicenseAgreement: {
    DataProtectionAccepted: boolean;
    DataProtectionAcceptedAt: string;
    DataProtectionVersion: string;
    IpAddress: string;
    ToSAccepted: true;
    ToSAcceptedAt: string;
    ToSVersion: string;
    UserAgent: string;
  };
  TestingOptIn?: boolean | null;
  CompanyUuid: string;
  ManualUploadNeeded: boolean;
  IsAmazonSeller: boolean | null;
  DATEVExportNeeded: boolean;
}

interface UserState {
  user: undefined | User;
  fresh: boolean;
  companies: UserCompany[];
  activeCompany: UserCompany | undefined;
}

const initialState: UserState = {
  user: undefined,
  fresh: false,
  companies: [],
  activeCompany: undefined,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (
      state,
      action: {
        payload: undefined | User;
      }
    ) => {
      state.user = action.payload;
    },
    setTestingOptIn: (state) => {
      if (state.user) {
        state.user.TestingOptIn = true;
      }
    },
    setFreshUser: (
      state,
      action: {
        payload: boolean;
      }
    ) => {
      state.fresh = action.payload;
    },
    clearUserState: (state) => {
      state.fresh = false;
      state.user = undefined;
      state.companies = [];
      state.activeCompany = undefined;
    },
    setUserCompanies: (
      state,
      action: {
        payload: UserCompany[];
      }
    ) => {
      state.companies = action.payload;
    },
    setActiveCompany: (
      state,
      action: {
        payload: UserCompany | undefined;
      }
    ) => {
      state.activeCompany = action.payload;
    },
  },
});

export const {
  setUser,
  setTestingOptIn,
  setFreshUser,
  clearUserState,
  setActiveCompany,
  setUserCompanies,
} = userSlice.actions;
export default userSlice.reducer;
